import { IFluidCodeDetails } from '@fluidframework/core-interfaces';
import { getOneNoteMeetingsCodeDetails } from '@ms/office-web-host';

export function getAgendaCodeDetails(): IFluidCodeDetails {
    return getOneNoteMeetingsCodeDetails();
}
